export const coords: any = {
  "mmrcl": {
    "Line 1": [
      { "x": 681.80, "y": 604.00 },
      { "x": 681.80, "y": 604.60 },
      { "x": 682.25, "y": 604.95 },
      { "x": 682.80, "y": 605.40 },
      { "x": 682.95, "y": 606.10 },
      { "x": 683.35, "y": 606.50 },
      { "x": 683.58, "y": 607.33 },
      { "x": 683.26, "y": 607.75 },
      { "x": 683.22, "y": 608.20 },
      { "x": 683.50, "y": 609.04 },
      { "x": 683.94, "y": 609.38 },
      { "x": 684.46, "y": 609.45 },
      { "x": 684.70, "y": 609.72 },
      { "x": 684.52, "y": 610.20 },
      { "x": 684.52, "y": 610.55 },
      { "x": 684.98, "y": 610.86 },
      { "x": 687.10, "y": 611.17, "hidden": true },
      { "x": 683.48, "y": 601.50, "hidden": true },
      { "x": 679.50, "y": 595.50, "hidden": true }
    ]
  },
}